var _rect, _rect2, _path, _g, _rect3, _path2, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCareerTech5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.666992,
    y: 0.333374,
    width: 46,
    height: 46,
    rx: 8,
    fill: "#26AC15"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_19209)"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "translate(11.667 11.3334)",
    fill: "#FF7140"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_19209",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 11,
    width: 25,
    height: 25
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.667 11.3334H11.667V35.3334H35.667V11.3334Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_19209)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.1939 11.4316C18.6202 10.5916 12.6082 15.2318 11.7652 21.8063C10.9252 28.3801 15.5655 34.3921 22.1399 35.2351C28.7137 36.0751 34.7257 31.4348 35.5649 24.8603C36.4087 18.2866 31.7692 12.2746 25.1939 11.4316ZM27.6629 18.9196C27.4402 18.9196 27.2287 19.0096 27.0727 19.1693L22.6199 23.6183L22.3117 23.3131L21.6704 22.6688C26.0572 18.2941 26.8507 18.2506 27.6622 18.9189L27.6629 18.9196ZM22.8037 23.7781L27.2407 19.3373C27.4867 19.0793 27.8969 19.0831 28.1437 19.3411C28.3859 19.6029 28.3619 20.0131 28.0889 20.2388L23.3902 24.3638L22.8037 23.7781ZM23.1322 24.4741L22.0304 24.7118C22.0072 24.7156 21.9764 24.7036 21.9644 24.6766C21.9524 24.6526 21.9562 24.6256 21.9764 24.6053L22.6207 23.9611L23.1322 24.4741ZM20.3272 24.0136L21.5032 22.8413L22.3822 23.7203L20.4015 24.1456C20.3662 24.1538 20.3317 24.1388 20.3152 24.1066C20.2965 24.0758 20.304 24.0368 20.3272 24.0136ZM16.683 30.0713C16.6402 30.0676 16.608 30.0286 16.6117 29.9896C16.6155 29.9708 16.6237 29.9543 16.6357 29.9423H16.6395L17.5845 28.9973L18.8077 30.2206L16.683 30.0713ZM19.1077 28.8136C19.0147 28.8646 18.9675 28.9703 18.9907 29.0716L19.194 29.9356C19.2262 30.0608 19.0732 30.1456 18.9832 30.0526H18.9795L17.7532 28.8256L21.5152 25.0673L23.3354 24.6736L24.2062 25.5488C22.9522 26.6498 21.2362 27.7478 19.1077 28.8136ZM24.3862 25.3883L23.5462 24.5483L28.2449 20.4233C28.2877 20.3843 28.3267 20.3416 28.3619 20.2981C28.2179 21.6421 26.3347 23.5403 24.3862 25.3883ZM28.0462 18.9271H28.0424C26.4052 17.2823 28.7182 14.7548 30.4994 16.2391L28.8907 17.8531C28.8434 17.8988 28.8434 17.9783 28.8907 18.0241L30.1364 19.2713C29.4374 19.6186 28.5974 19.4783 28.0462 18.9271ZM30.6202 18.9271C30.5384 19.0088 30.4484 19.0831 30.3509 19.1453L29.1442 17.9386L30.6749 16.4033C31.3387 17.1263 31.3117 18.2356 30.6202 18.9271ZM30.5219 17.3843C30.4717 17.4196 30.4522 17.4811 30.4679 17.5403C30.5422 17.6881 30.5219 17.8643 30.4169 17.9896C30.3659 18.0526 30.3779 18.1388 30.4402 18.1883C30.4642 18.2041 30.4912 18.2161 30.5219 18.2161C30.5647 18.2161 30.6052 18.2003 30.6277 18.1689C30.8039 17.9581 30.8384 17.6611 30.7177 17.4151C30.6704 17.3528 30.5849 17.3371 30.5219 17.3843Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1_19209)"
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "translate(11.667 11.3334)",
    fill: "#26AC15"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1_19209",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 11,
    width: 25,
    height: 25
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.667 11.3334H11.667V35.3334H35.667V11.3334Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1_19209)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.2295 24.4899C29.1278 24.4899 28.0927 24.0249 27.1552 23.2637L27.3817 22.1897L27.3892 22.1469C27.5962 21.0062 28.2367 19.0884 30.2288 19.0884C31.7213 19.0884 32.9318 20.2997 32.9318 21.7914C32.9318 23.2794 31.7205 24.4907 30.2288 24.4907L30.2295 24.4899ZM30.2295 16.3532C27.6908 16.3532 25.7175 18.0017 24.9172 20.7167C23.6985 18.8844 22.7685 16.6817 22.23 14.8262H19.4955V21.9392C19.4917 23.3454 18.3547 24.4824 16.9485 24.4862C15.5422 24.4824 14.4052 23.3417 14.4015 21.9392V14.8262H11.667V21.9392C11.667 24.8529 14.0377 27.2402 16.9485 27.2402C19.8622 27.2402 22.23 24.8537 22.23 21.9392V20.7474C22.761 21.8529 23.4135 22.9779 24.2062 23.9702L22.5307 31.8414H25.3275L26.5425 26.1302C27.6052 26.8097 28.8277 27.2394 30.2302 27.2394C33.2302 27.2394 35.6677 24.7862 35.6677 21.7899C35.6677 18.7899 33.2302 16.3524 30.2302 16.3524L30.2295 16.3532Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_19209"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(11.667 11.3334)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1_19209"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(11.667 11.3334)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCareerTech5);
export default __webpack_public_path__ + "static/media/careerTech5.49f21706a8d6b0ef08ffc1f8c510c7ac.svg";
export { ForwardRef as ReactComponent };